import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody,
  Button, Text, Flex, Alert, AlertIcon,
} from '@chakra-ui/react';
import * as FiIcons from 'react-icons/fi';
import { deleteService } from '../../../../../store/services/servicesSlice';
import theme from '../../../../global/theme';

const DeleteModal = ({ data, onClose }) => {
  const dispatch = useDispatch();
  const services = useSelector(state => state.services);

  return (
    <Modal isOpen onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent borderRadius={4} paddingBlock={4} bg={theme.dark}>
        <ModalHeader textAlign="center" color="red.400" fontSize={20}>حذف الخدمة</ModalHeader>
        <ModalBody>
          {services.errors.length > 0 && (
            <Alert status="error" variant="left-accent" marginBottom={4}>
              <AlertIcon />
              {services.errors.map((e, i) => <Text key={i}>{e?.msg}</Text>)}
            </Alert>
          )}
          <Text color={theme.light} textAlign="center">
            هل أنت متأكد من حذف الخدمة <strong>{data.title}</strong>؟
          </Text>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="center" gap={3} width="100%">
            <Button rightIcon={<FiIcons.FiTrash2 />} colorScheme="red" isLoading={services.isLoading}
              onClick={() => dispatch(deleteService(data)).unwrap().then(() => onClose())}>
              حذف
            </Button>
            <Button rightIcon={<FiIcons.FiX />} colorScheme="gray"
              isLoading={services.isLoading} onClick={onClose}>إلغاء</Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default DeleteModal;
